<template>
    <div class="wrapper-full-page section content" >
        <div class="" v-if="this.$store.state.permit.RulesUser.roles.includes('staff')">
            <div class="col-md-6 offset-md-3">
                <h3 style="font-weight:100" class="mt-5 font-en mt-0 mb-3">
                    <b><i class="fa fa-id-badge mr-2" aria-hidden="true"></i>IC Staff : Add Card Data</b>
                </h3>
                <hr>
                <!-- 
                    <Keypress :multiple-keys="multiple" key-event="keyup"  @success="callModalUpdata" @wrong="otherMethod" />
                    <b-input hidden v-model="valKey"></b-input> 
                -->
                <h5 class="mt-3 font-thai"><b>Step 1 :</b> เลือกประเภทของ User</h5>
                <b-form-radio-group
                    v-model="checked"
                    :options="options"
                    name="radio-size" 
                    stacked
                    @change="clearInput"
                    size="lg"
                ></b-form-radio-group>
                <h5 class="mt-4 mb-0 font-thai"><b>Step 2 :</b> ใส่รหัสประจำตัว</h5>
                <h5 class="mt-1 mb-2 font-thai"><u>ตัวอย่าง ID</u> : {{ checked === 'Student' ? 'YY8xxxx' : '13xxxxxx , 23xxxxxx ( Aj.Parttime )' }}</h5>
                <b-form-input @input="callProfile" v-model="idStudent" placeholder="Enter Id"></b-form-input>
                <b-card class="mt-3" header="Data Result profile">
                    <pre v-if="itemProfile.length != 0" class="m-0">{{ itemProfile[0] }}</pre>
                    <span v-else class="text-danger ml-3"><b>Not Found Id</b></span>
                </b-card>
                <h5 class="mt-2 mb-2 font-thai"><b>Step 3 : เพิ่มข้อมูลบัตร</b></h5>
                <label class="mt-2 font-en-chk">Token ID Card : 18digits 125k</label>
                <b-form-input v-model="tokenIdCard" placeholder="please enter student Id or Staff Id" ></b-form-input>
                <label class="mt-2 font-en-chk">Token ID Card : 14digits (Kyocera)</label>
                <b-form-input v-model="tokenIdCardKyo" placeholder="please enter student Id or Staff Id" ></b-form-input>
                <!-- <div class="font-thai text-muted pointBottom"><i>TokenID : {{ valKey }}</i></div> -->
                <hr>
                <div class="mt-3">
                    <b-button @click="AddDataCard" class="font-weight-bold mr-2" variant="success">Update Data Card.</b-button>
                    <b-button @click="clearInput" class="font-weight-bold" variant="danger">Clear.</b-button>
                </div>
            </div>
        </div>
        <div v-else>Not Permit..</div>
    </div>
</template>

<style lang="scss" scoped>
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .font-thai{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .font-en-chk{ font-family: 'Rubik', sans-serif; font-weight: 300; }
</style>

<script>
    import store from "@/store/index";
    export default {
        components: {
            Keypress: () => import('vue-keypress'),
            store
        },
        data() {
            return {
                idStudent:null,
                tokenIdCard: "",
                tokenIdCardKyo: "",
                getId:true,
                checked: 'Student',
                options: [
                    { text: 'Student', value: 'Student' },
                    { text: 'Staff', value: 'Staff' },
                ],
                itemProfile:[],
                valKey: '',
                valTemp: 'Key name',
                multiple: [
                    {
                        keyCode: 13, // Enter
                        modifiers: [],
                        preventDefault: true,
                    },
                ],
            }
        },
        computed: {},
        mounted(){},
        methods: {
            clearInput(){
                this.itemProfile = []
                this.idStudent = null
                this.tokenIdCard = ""
                this.tokenIdCardKyo = ""
                this.getId = true
            },
            makeToast(variant = null) {
                this.$bvToast.toast('Success Update', {
                    title: 'Card data update !!',
                    variant: variant,
                    solid: true
                })
            },
            async callProfile(){
                this.tokenIdCard = ""
                this.tokenIdCardKyo = ""
                this.itemProfile = []
                if(this.checked === 'Student'){
                    if(this.idStudent.length === 7 || this.idStudent.length === 6){
                        try {
                            const res = await this.$http.get(`/student/edit/${this.idStudent}/`)
                            if(res.status === 200){
                                this.itemProfile.push({
                                    'student_id' : res.data.student_id,
                                    'Name' : `${res.data.title} ${res.data.english_first_name} ${res.data.english_middle_name} ${res.data.english_last_name}`,
                                    'id_card' : res.data.id_card
                                })
                                if(res.data.id_card){
                                    var idCard = res.data.id_card.split(",")
                                    // console.log(idCard)
                                    for (let i = 0; i < idCard.length; i++) {
                                        // console.log(idCard[i]);
                                        if(idCard[i].length == 14){ this.tokenIdCardKyo = idCard[i] }
                                        else{ this.tokenIdCard = idCard[i] }
                                    }
                                }
                                this.getId = false
                            }
                        } catch (error) {}
                    }
                }else{
                    if(this.idStudent.length === 8){
                        try {
                            const res = await this.$http.get(`/staff/profile/${this.idStudent}/`)
                            if(res.status === 200){
                                // console.log(res.data)
                                this.tokenIdCard = res.data.card_18digits_125k
                                this.tokenIdCardKyo = res.data.card_14digits
                                this.itemProfile.push({
                                    'staff_id' : res.data.user_type !== null ? res.data.user_type.name_eng === 'AJ. Part-time' ? res.data.code : res.data.code : res.data.code,
                                    'Name' : `${res.data.name} ${res.data.surname}`,
                                    'user_type' : res.data.user_type !== null ? `${res.data.user_type.name_eng}` : '',
                                    'card_18digits_125k' : res.data.card_18digits_125k,
                                    'card_14digits' : res.data.card_14digits
                                })
                                this.getId = false
                            }
                        } catch (error) {}
                    }
                }
            },
            async AddDataCard() {
                if(this.checked === 'Student'){
                    try {
                        const sendData = new FormData()
                        if(this.tokenIdCard !== "" && this.tokenIdCardKyo !== ""){
                            var sendKey = `${this.tokenIdCard},${this.tokenIdCardKyo}`
                        }else if(this.tokenIdCard !== "" && this.tokenIdCardKyo === ""){
                            var sendKey = `${this.tokenIdCard}`
                        }else if(this.tokenIdCard === "" && this.tokenIdCardKyo !== ""){
                            var sendKey = `${this.tokenIdCardKyo}`
                        }else{
                            var sendKey = ""
                        }
                        sendData.append('id_card', sendKey)
                        const response = await this.$http.patch(`/student/edit/${this.idStudent}/`,
                            sendData,
                            {
                                headers: { 'Content-Type': 'multipart/form-data' }
                            }
                        )
                        if(response.status === 200){
                            this.callProfile()
                            this.makeToast('success')
                        }
                    } catch (error) {} 
                }else{
                    const sendData = new FormData()
                    sendData.append('card_18digits_125k', this.tokenIdCard)
                    sendData.append('card_14digits', this.tokenIdCardKyo !== null ? this.tokenIdCardKyo : '')
                    const response = await this.$http.patch(`/staff/profile/${this.idStudent}/`,
                        sendData,
                        {
                            headers: { 'Content-Type': 'multipart/form-data' }
                        }
                    )
                    if(response.status === 200){
                        this.callProfile()
                        this.makeToast('success')
                    }
                }
            },
            // otherMethod(response){
            //     if(response.event.keyCode >= 48 && response.event.keyCode <= 57){
            //         var temp = response.event.keyCode-48
            //         this.valKey += `${temp}`
            //     }else if(response.event.keyCode >= 96 && response.event.keyCode <= 105){
            //         var temp = response.event.keyCode-96
            //         this.valKey += `${temp}`
            //     }else if(response.event.keyCode === 8 || response.event.keyCode === 46){
            //         this.valKey = this.valKey.substring(0, this.valKey.length - 1);
            //     }else if(response.event.keyCode == 188){
            //         this.valKey = this.valKey+','
            //     }
            // },
        }
    }
</script>